import { Injectable } from '@angular/core';
import { SocialRed } from '@app/_models/social-media/social-media.model';

@Injectable({
    providedIn: 'root',
})
export class SocialMediaHelper {
    socialMediaList: SocialRed[] = [
        {
            type: 'other',
            regexp: new RegExp(
                /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
            ),
            icon: 'fal fa-globe social-icon',
        },
        {
            type: 'facebook',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?(?:facebook|fb)\.com/),
            icon: 'fab fa-facebook social-icon',
        },
        {
            type: 'instagram',
            regexp: new RegExp(
                /(?:https?:\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/
            ),
            icon: 'fab fa-instagram social-icon',
        },
        {
            type: 'x-twitter',
            regexp: new RegExp(
                /(?:https?:\/\/)?(?:[A-z]+\.)?(?:twitter\.com|x\.com)\/@?(?!home|sharegexp|privacy|tos)([A-z0-9_]+)\/?/
            ),
            icon: 'fab fa-x-twitter social-icon',
        },
        {
            type: 'youtube',
            // regexp: new RegExp(
            //     /(?:https?:\/\/)?(?:[A-z]+\\.)?youtube.com\/(c|channel|user|watch)(\/|\?)([A-z0-9-\\_]+)\/?/
            // ),

            // regexp: new RegExp(
            //     /(?:https?:\/\/)?(?:[A-z]+\\.)?youtube.com\/(@[\w\d]+$)|(c|channel|user|watch)(\/|\?)([A-z0-9-\\_]+)\/?/
            // ),

            regexp: new RegExp(
                /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:(?:@[\w\d-_]+)|(c\/[\w\d-_]+)|(shorts\/[\w\d-_]+)|(channel\/[\w\d-_]+)|(user\/[\w\d-_]+)|(watch\?v=[\w\d-_]+))/
            ),

            /**
             * Detalle de la expresion regular:
             * (?:https?:\/\/)?
                Permite que la URL comience opcionalmente con http:// o https://.

                (?:www\.)?
                Permite que la URL comience opcionalmente con www..

                youtube\.com\/
                Verifica que el dominio sea youtube.com.

                (?:@[\w\d-_]+)
                Coincide con URLs que contienen @username.

                (c\/[\w\d-_]+)
                Coincide con URLs de canales (c/channelName).

                (channel\/[\w\d-_]+)
                Coincide con URLs de canales que usan channel/channelId.

                (user\/[\w\d-_]+)
                Coincide con URLs que usan user/username.

                (watch\?v=[\w\d-_]+)
                Coincide con URLs de videos específicos.

                (channel\/[\w\d-_]+)
                Coincide con URLs de shorts
             */
            icon: 'fab fa-youtube social-icon',
        },
        {
            type: 'linkedin',
            regexp: new RegExp(
                /(?:https?:)?\/\/(?:[\w]+\.)?linkedin\.com\/(in|company)\/(?!<permalink>[\w\-\_À-ÿ%]+)\/?/
            ),
            icon: 'fab fa-linkedin social-icon',
        },
        {
            type: 'tiktok',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?tiktok\.com/),
            icon: 'fab fa-tiktok social-icon',
        },
        /* {
            type: 'x',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com/),
            icon: 'fab fa-x-twitter social-icon',
        },
        */
        {
            type: 'spotify',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?spotify\.com/),
            icon: 'fab fa-spotify social-icon',
        },
        {
            type: 'twitch ',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?twitch\.tv/),
            icon: 'fab fa-twitch social-icon',
        },
        {
            type: 'telegram ',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?t\.me|telegram\.me/),
            icon: 'fab fa-telegram social-icon',
        },
        {
            type: 'pinterest ',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?pinterest\.com/),
            icon: 'fab fa-pinterest social-icon',
        },
        {
            type: 'snapchat',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?snapchat\.com/),
            icon: 'fab fa-snapchat social-icon',
        },
        {
            type: 'threads',
            regexp: new RegExp(/(?:https?:\/\/)?(?:www\.)?threads\.net/),
            icon: 'fa-brands fa-threads social-icon',
        },
    ];

    socialExist(socialUrl) {
        let socialItem: SocialRed;
        this.socialMediaList.forEach((item: SocialRed) => {
            if (item.regexp.test(socialUrl)) {
                socialItem = item;
            }
        });
        return socialItem;
    }
}
